export const NEW_CRM_SHIFT_TURNOVER = 'New CRM Shift Turnover';
export const NEW_MOC_EVENT = 'New MOC Event';

// CRM Actions

export const PRINT_SHIFT_TURNOVER = 'print-shift';
export const DEPARTING_COMPLETED = 'departing-complete';
export const INCOMING_COMPLETED = 'incoming-complete';
export const RESOLVE_SHIFT_TURNOVER = 'resolve';

export const ACKNOWLEDGE_MOC = 'acknowledge-moc';
export const MANUALLY_CLOSE_MOC = 'manually-close-moc';
export const DELETE_MOC_EVENT = 'delete-moc-event';

// Tab Prefixes and Names
export const CRM_ST_TAB_PREFIX = 'CRM Shift Turnover: ';
export const MOC_EVENT_TAB_PREFIX = 'MOC Event: ';

// MOC Event Constants
export const EVENT_TYPE_PERMANENT = 'Permanent';
export const EVENT_TYPE_SCHEDULED = 'Scheduled';
export const EVENT_STATUS_OPEN = 'Open';
export const EVENT_STATUS_CLOSED = 'Closed';
export const EVENT_STATUS_UPCOMING = 'Upcoming';
